import { observer } from "mobx-react-lite";
import { UserAccountStore, CommonStore } from "../../../store";
import { Fragment, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Space,
  Table,
  Row,
  Col,
  Modal,
  Select,
  DatePicker,
  Checkbox,
  Tooltip,
  Empty,
  ConfigProvider,
  Menu,
  Dropdown,
} from "antd";
import UpdateOrAdd from "./updateOrAdd";
import "./index.css";
import { MoreOutlined, UpOutlined, DownOutlined } from "@ant-design/icons";

const { Column } = Table;
const CheckboxGroup = Checkbox.Group;
const { RangePicker } = DatePicker;

function UserAccountPage() {
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    form.setFieldsValue({
      phoneNumber: "",
      displayName: "",
      isEnable: true,
      groupNo: null,
      expiredTime: null,
    });
    resetSearchbth();
  }, []);

  const getFormData = (
    changeValue: powerSearchData,
    allValues: powerSearchData
  ) => {
    allValues.startTime = UserAccountStore.searchForm.startTime;
    allValues.endTime = UserAccountStore.searchForm.endTime;
    UserAccountStore.setSearchForm({ ...allValues });
  };
  const searchBtn = () => {
    UserAccountStore.resetPage();
    UserAccountStore.getPowerPage();
  };
  const resetSearchbth = () => {
    UserAccountStore.setSearchForm({ isEnable: true });
    searchBtn();
  };

  const addPower = (data?: any) => {
    if (data) {
      UserAccountStore.addOrUpdateModal.open("update", data);
    } else {
      UserAccountStore.addOrUpdateModal.open("add");
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = (accountNo: any) => {
    UserAccountStore.getRelationAccountGroup(accountNo);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    UserAccountStore.setRelationAccountGroup();
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const moreOperationsClick = (e: any, record: any) => {
    if (e.key === "1") {
      return showModal(record.no);
    } else if (e.key === "2") {
      return UserAccountStore.deletePower(record.no);
    } else if (e.key === "3") {
      return UserAccountStore.changeIsEnable(record.isEnable, record.no);
    }
  };
  const moreOperations = (record: any) => {
    return [
      {
        label: "关联用户组",
        key: "1",
      },
      {
        label: "删除账户",
        key: "2",
        style: { color: "red", display: record.manageable ? "" : "none" },
      },
      {
        label: record.isEnable ? "禁用" : "启用",
        key: "3",
        style: {
          color: record.isEnable ? "red" : "",
          display: record.manageable ? "" : "none",
        },
      },
    ];
  };
  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };
  return (
    <Fragment>
      <UpdateOrAdd></UpdateOrAdd>
      <div className="formContent">
        <Form
          form={form}
          initialValues={UserAccountStore.searchForm}
          autoComplete="off"
          labelCol={{ span: 6 }}
          onValuesChange={getFormData}
        >
          <Row justify="start">
            <Col span={8}>
              <Form.Item label="手机号" name="phoneNumber">
                <Input placeholder="请输入手机号" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="昵称" name="displayName">
                <Input placeholder="请输入昵称" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="账户状态" name="isEnable">
                <Select style={{ width: "98%" }}>
                  <Option value={true}>启用</Option>
                  <Option value={false}>禁用</Option>
                  <Option value={""}>全部</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <ConfigProvider renderEmpty={tableEmptyRender}>
                <Form.Item label="关联用户组" name="groupNo">
                  <Select
                    onChange={UserAccountStore.handleChange}
                    placeholder="请选择关联用户组"
                  >
                    {Array.from(UserAccountStore.manageAccountReadList)
                      ? Array.from(UserAccountStore.manageAccountReadList).map(
                          (value: any, index: any) => {
                            return (
                              <Option value={value.no} key={value.no}>
                                {value.displayName}
                              </Option>
                            );
                          }
                        )
                      : ""}
                  </Select>
                </Form.Item>
              </ConfigProvider>
            </Col>
            <Col span={8}>
              {/*{CommonStore.showMore && (*/}
              <Form.Item
                label="过期时间"
                name="expiredTime"
                // labelCol={{span: 3}}
              >
                <RangePicker
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                  placeholder={["开始时间", "结束时间"]}
                />
              </Form.Item>
              {/*)}*/}
            </Col>
            <Col offset={2}>
              <Form.Item>
                <Space>
                  <Button type="primary" onClick={searchBtn}>
                    搜索
                  </Button>
                  <Button htmlType="reset" onClick={resetSearchbth}>
                    重置
                  </Button>
                  {/*<Button*/}
                  {/*    type="link"*/}
                  {/*    onClick={() => CommonStore.advancedSearch()}*/}
                  {/*>*/}
                  {/*    高级搜索{CommonStore.showMore && <UpOutlined/>}*/}
                  {/*    {!CommonStore.showMore && <DownOutlined/>}*/}
                  {/*</Button>*/}
                </Space>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8} offset={16}>
              {CommonStore.pagePermission.manageable && (
                <Button
                  type="primary"
                  style={{ float: "right", marginBottom: "10px" }}
                  onClick={() => addPower()}
                >
                  邀请
                </Button>
              )}
            </Col>
          </Row>
        </Form>
      </div>
      <ConfigProvider renderEmpty={tableEmptyRender}>
        <Table
          dataSource={UserAccountStore.tableData.records}
          rowKey={(record: { no: string }) => record.no}
          loading={UserAccountStore.tableLoad}
          scroll={{ x: 1400 }}
          pagination={{
            current: UserAccountStore.pageData.page,
            pageSize: UserAccountStore.pageData.size,
            onChange: UserAccountStore.pageData.changePage,
            pageSizeOptions: [10, 25, 50],
            showSizeChanger: true,
            total: UserAccountStore.tableData.total,
            showTotal: () => `共计${UserAccountStore.tableData.total}条`,
            position: ["bottomLeft"],
          }}
        >
          <Column
            ellipsis={true}
            fixed='left'
            title="手机号"
            width={130}
            dataIndex="phoneNumber"
            render={(phoneNumber) => (
              <Tooltip placement="topLeft">{phoneNumber}</Tooltip>
            )}
          />
          <Column
            ellipsis={true}
            title="昵称"
            width={120}
            dataIndex="displayName"
          />
          <Column
            title="关联用户组"
            dataIndex="userAccountGroup"
            ellipsis={true}
            width={160}
          />
          <Column
            title="过期时间"
            width={120}
            dataIndex="expiredTime"
            render={(expiredTime) => (expiredTime ? expiredTime : "永久")}
            ellipsis={true}
          />
          <Column
            title="账户状态"
            width={120}
            dataIndex="isEnable"
            render={(isEnable) => (isEnable ? "启用" : "禁用")}
            ellipsis={true}
          />
          <Column
            width={120}
            title="邀请人"
            dataIndex="creator"
            ellipsis={true}
          />
          <Column
            title="创建时间"
            width={200}
            className="minsty"
            dataIndex="createTime"
            ellipsis={true}
          />
          <Column
            title="更新时间"
            width={200}
            dataIndex="updateTime"
            ellipsis={true}
          />
          <Column
            width={120}
            fixed={"right"}
            render={(text: string, record: any) => (
              <Space>
                {record.writeable && (
                  <Button size={"small"} onClick={() => addPower(record)}>
                    编辑
                  </Button>
                )}
                <Dropdown
                  // {...moreOperations}
                  dropdownRender={() => (
                    <Menu
                      onClick={(e) => moreOperationsClick(e, record)}
                      className={"menuSty"}
                      items={moreOperations(record)}
                    >
                      {/* {moreOperations.map((item) => {
                          return (
                            (item.label == "关联用户组" && (
                              <Menu.Item key={item.key}>
                                <span>{item.label}</span>
                              </Menu.Item>
                            )) ||
                            (item.label == "删除账户" && record.manageable && (
                              <Menu.Item key={item.key}>
                                <span className={"colorSty"}>{item.label}</span>
                              </Menu.Item>
                            )) ||
                            (!item.label && record.manageable && (
                              <Menu.Item key={item.key}>
                                <span
                                  className={record.isEnable ? "colorSty" : ""}
                                >
                                  {record.isEnable ? "禁用" : "启用"}
                                </span>
                              </Menu.Item>
                            ))
                          );
                        })} */}
                    </Menu>
                  )}
                >
                  <Button size={"small"}>
                    <MoreOutlined />
                  </Button>
                </Dropdown>
              </Space>
            )}
          />
        </Table>
      </ConfigProvider>
      <Modal
        title="编辑关联用户组"
        open={isModalOpen}
        onOk={handleOk}
        width={'600px'}
        centered
        okText="确定"
        cancelText="取消"
        loading={UserAccountStore.modalLoading}
        onCancel={handleCancel}
      >
        <br />
        <div className="containerSty">
          <CheckboxGroup
            value={UserAccountStore.checkedList}
            onChange={(list) => UserAccountStore.changeCheckList(list)}
          >
            {UserAccountStore.getRelationListAll.map(
              (item: any, index: any) => (
                <div className="contentSty" key={item.value}>
                  <Checkbox value={item.value} disabled={item.disabled}>
                    {item.label}
                  </Checkbox>
                </div>
              )
            )}
          </CheckboxGroup>
        </div>
      </Modal>
    </Fragment>
  );
}

export default observer(UserAccountPage);
